// onsiparis: sepet uyarı bandının görünürlüğünü canlı tutar.
// Temannın sepeti hangi yöntemle güncellediğini (kısmi DOM yaması,
// tüm seçsiyonu değiştirme, vb.) bilmemize gerek kalmadan çalışsın diye
// hem MutationObserver hem de kısa aralıklı bir kontrol (polling) birlikte
// kullanılıyor. Düzenli aralıklarla sayfadaki GERÇEK DOM durumuna bakılıp
// banner'lar buna göre gösterilip gizleniyor; böylece hangi yöntemle
// güncellenirse güncellensin en geç ~400ms içinde doğru duruma döner.
(function () {
  function refresh() {
    var hasPreorder = !!document.querySelector('[data-preorder-item="true"]');
    var notices = document.querySelectorAll('[data-preorder-cart-notice]');
    for (var i = 0; i < notices.length; i++) {
      notices[i].classList.toggle('hidden', !hasPreorder);
    }
  }

  function init() {
    refresh();

    var observer = new MutationObserver(refresh);
    observer.observe(document.body, { childList: true, subtree: true });

    // Emniyet ağı: MutationObserver bir değişikliği kaçırırsa bile
    // en geç 400ms içinde durum kendiliğinden düzelir.
    setInterval(refresh, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Barem kampanya çubuğu (snippets/barem-progress-bar.liquid):
// Sepet değiştiğinde (ekleme, adet değişikliği, güncelleme, temizleme)
// /cart.js'ten ara toplamı okuyup çubuğu, mesajı ve kademe noktalarını yeniler.
// Tema sepeti ister tamamen ister kısmen yenilesin, istek bitince çalışır.
(function () {
  if (window.sgBaremReady) return;
  window.sgBaremReady = true;

  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;
  var latest = 0;

  function tl(cents) {
    return Math.ceil(cents / 100).toLocaleString('tr-TR') + '₺';
  }

  function render(el, total) {
    var t1 = Number(el.getAttribute('data-t1'));
    var d1 = Number(el.getAttribute('data-d1'));
    var t2 = Number(el.getAttribute('data-t2'));
    var d2 = Number(el.getAttribute('data-d2'));
    if (!t1 || !t2) return;
    var state = total >= t2 ? 3 : total >= t1 ? 2 : 1;
    var msg;
    if (state === 1) {
      msg = 'Sepetine <strong>' + tl(t1 - total) + '</strong> daha ekle, <strong>' + tl(d1) + ' indirim</strong> kazan!';
    } else if (state === 2) {
      msg = '<strong>' + tl(d1) + ' indirim kazandın!</strong> <strong>' + tl(t2 - total) + '</strong> daha ekle, indirimin <strong>' + tl(d2) + '</strong> olsun.';
    } else {
      msg = 'Tebrikler! <strong>' + tl(d2) + ' indirim</strong> sepetine uygulandı.';
    }
    el.classList.remove('sg-barem--s1', 'sg-barem--s2', 'sg-barem--s3');
    el.classList.add('sg-barem--s' + state);
    var msgEl = el.querySelector('[data-barem-msg]');
    if (msgEl) msgEl.innerHTML = msg;
    var fill = el.querySelector('[data-barem-fill]');
    if (fill) fill.style.width = Math.min(100, (total * 100) / t2) + '%';
    var track = el.querySelector('[data-barem-track]');
    if (track) track.setAttribute('aria-valuenow', String(Math.floor(total / 100)));
    var steps = el.querySelectorAll('[data-barem-dot], [data-barem-mark]');
    for (var i = 0; i < steps.length; i++) {
      var k = Number(steps[i].getAttribute('data-barem-dot') || steps[i].getAttribute('data-barem-mark'));
      steps[i].classList.toggle('is-on', state > k);
    }
  }

  function refresh() {
    if (!document.querySelector('[data-barem-bar]')) return;
    var id = ++latest;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (id !== latest) return;
        var bars = document.querySelectorAll('[data-barem-bar]');
        for (var i = 0; i < bars.length; i++) render(bars[i], cart.items_subtotal_price || 0);
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 200);
  }

  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (CART_CHANGE.test(entries[i].name)) {
            schedule();
            break;
          }
        }
      }).observe({ entryTypes: ['resource'] });
    } catch (e) {}
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });

  window.sgBaremRender = render;
})();
